import React from 'react'
import { UsuarioPreparacao } from '@newspacebpo/mf_protocolo_bfveic'
const UsuarioPreparacaoPage = (props) => {
    return (
            <UsuarioPreparacao {...props}/>
    );
};

export { UsuarioPreparacaoPage };